import {MultilingualMax50FieldRestDto, PopupRestDto} from "@/api/pharma-cms-popup/models";
import {StatusEnum} from "@/api/enums/status-enum";
import {PopupLayoutEnum} from "@/api/enums/popup-layout-enum";
import {PopupSizeEnum} from "@/api/enums/popup-size-enum";
import {PopupVerticalPositionEnum} from "@/api/enums/popup-vertical-position-enum";

export class PopupRestDtoModel implements PopupRestDto {
    name: string;
    status_code?: StatusEnum|null;
    layout_code: PopupLayoutEnum;
    body_page:  MultilingualMax50FieldRestDto;
    do_not_show_duration_in_sec?: number|null;
    buttons: string[];
    size_code: PopupSizeEnum;
    vertical_position_code: PopupVerticalPositionEnum;

    constructor(
        name: string,
        layout_code: PopupLayoutEnum,
        body_page:  MultilingualMax50FieldRestDto,
        size_code: PopupSizeEnum,
        vertical_position_code: PopupVerticalPositionEnum,
        do_not_show_duration_in_sec: number | null = null,
    ) {
        this.name = name;
        this.layout_code = layout_code;
        this.body_page = body_page;
        this.buttons = [];
        this.size_code = size_code;
        this.vertical_position_code = vertical_position_code;
        this.do_not_show_duration_in_sec = do_not_show_duration_in_sec;
    }

    public static createWithDefaults(): PopupRestDtoModel {
        return new this(
            '',
            PopupLayoutEnum.DEFAULT,
            {},
            PopupSizeEnum.DEFAULT,
            PopupVerticalPositionEnum.CENTER,
            60 * 60 * 24 * 7,
        );
    }
}
